import { isPlainObject, toKebabCase } from "./css.js";
function formatTokenKey(key, useKebabCase) {
  if (/^\d/.test(key)) {
    return key;
  }
  if (useKebabCase) {
    return toKebabCase(key);
  }
  return key.charAt(0) + key.slice(1);
}
function fromTokens(tokenObj, prefix, options = {}) {
  const { kebabCase = false, formatKey = formatTokenKey } = options;
  const cssVars = {};
  Object.entries(tokenObj).forEach(([key, value]) => {
    if (!isPlainObject(value)) {
      const formattedKey = formatKey(key, kebabCase);
      const varName = `--${prefix}${formattedKey}`;
      cssVars[varName] = value;
    }
  });
  Object.entries(tokenObj).forEach(([key, value]) => {
    if (isPlainObject(value)) {
      const formattedKey = formatKey(key, kebabCase);
      const nestedPrefix = `${prefix}${formattedKey}-`;
      const nestedVars = fromTokens(value, nestedPrefix, options);
      Object.assign(cssVars, nestedVars);
    }
  });
  return cssVars;
}
function toCssObject(cssVarsObj) {
  const rules = Object.entries(cssVarsObj).map(([name, value]) => `  '${name}': '${value}',`).join("\n");
  return `{
${rules}
};`;
}
function toString(cssVarsObj) {
  const rules = Object.entries(cssVarsObj).map(([name, value]) => `  '${name}': '${value}';`).join("\n");
  return `${rules}`;
}
function generateTokensCSS(color, spacing, font, media) {
  const cssVars = [];
  const flattenTokens = (obj, prefix) => {
    const vars = [];
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === "object" && value !== null) {
        vars.push(...flattenTokens(value, `${prefix}-${key}`));
      } else {
        const kebabKey = toKebabCase(key);
        vars.push(`--${prefix}-${kebabKey}: ${value};`);
      }
    }
    return vars;
  };
  cssVars.push("/* Color Tokens */");
  cssVars.push(...flattenTokens(color, "umd-color"));
  cssVars.push("\n/* Spacing Tokens */");
  for (const [key, value] of Object.entries(spacing)) {
    if (typeof value === "string") {
      cssVars.push(`--umd-space-${key}: ${value};`);
    } else if (key === "maxWidth" && typeof value === "object") {
      for (const [mwKey, mwValue] of Object.entries(value)) {
        cssVars.push(`--umd-space-max-width-${mwKey}: ${mwValue};`);
      }
    }
  }
  cssVars.push("\n/* Font Size Tokens */");
  for (const [key, value] of Object.entries(font.size)) {
    cssVars.push(`--umd-font-size-${key}: ${value};`);
  }
  cssVars.push("\n/* Font Family Tokens */");
  cssVars.push(`--umd-font-serif: ${font.family.serif};`);
  cssVars.push(`--umd-font-sans: ${font.family.sans};`);
  cssVars.push(`--umd-font-campaign: ${font.family.campaign};`);
  cssVars.push(`--umd-font-mono: ${font.family.mono};`);
  const rootBlock = `:root {
  ${cssVars.join("\n  ")}
}`;
  const mediaBlocks = [];
  for (const [key, value] of Object.entries(media.conditionals)) {
    if (key.startsWith("@media")) {
      const innerVars = Object.entries(value).map(([k, v]) => `${k}: ${v};`).join(" ");
      mediaBlocks.push(`${key} { :root { ${innerVars} } }`);
    }
  }
  return `${rootBlock}

${mediaBlocks.join("\n")}`;
}
export {
  formatTokenKey,
  fromTokens,
  generateTokensCSS,
  toCssObject,
  toString
};
//# sourceMappingURL=variables.js.map
